import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NewsletterService } from "boho-casas-client-module/client-web";
import CalculatorFooter from "../Calculator/FooterCalculator";
import PrivacyPolicyModal from "../../molecules/FormSendMessage/PrivacyPolicyModal";
import { useLanguage } from "../../../utils/translations/LanguageContext";
import TermsAndConditionsModal from "../../atoms/TermsAndConditionsModal/TermsAndConditionsModal";

const scrollToAboutUs = () => {
  const contactSection = document.getElementById("AboutUs");
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: "smooth" });
  }
};
const handleClick = () => {
  window.scrollTo(0, 0);
};
const scrollToTop = () => {
  const scrollTop = window.scrollY;
  const duration = 3000; // Scroll duration in milliseconds
  const startTime = performance.now();

  const animateScroll = (currentTime) => {
    const elapsedTime = currentTime - startTime;
    if (elapsedTime < duration) {
      const easing = easeOutQuad(elapsedTime, scrollTop, -scrollTop, duration);
      window.scrollTo(0, easing);
      requestAnimationFrame(animateScroll);
    } else {
      window.scrollTo(0, 0);
    }
  };

  const easeOutQuad = (t, b, c, d) => {
    t /= d;
    return -c * t * (t - 2) + b;
  };

  requestAnimationFrame(animateScroll);
};
const FooterStyles = {
  height: "450px",
  width: "100%",
  backgroundColor: "#51787D",
  display: "flex",
  alignItems: "flex-start",
  paddingTop: "80px",
  margin: "auto",
  justifyContent: "space-between",
  color: "var(--token-colors-text-plain-text-dark, #FFF)",
  fontFamily: "Maven Pro",
  fontSize: "14px",
  fontStyle: "normal",
  lineHeight: "24px",
  position: "relative",
};

const FooterColumnStyles = {
  width: "60%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const titleColumn1 = {
  fontSize: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "auto",
  alignItems: "stretch",
};
const titleColumn2 = {
  fontSize: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "auto",
  alignItems: "stretch",
};

const titleColumn4 = {
  fontSize: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "auto",
};

const marginLinks = {
  paddingBottom: "10px",
  textDecoration: "none",
  color: "white",
};

const getDirections = {
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
};

const ButtonSubmit = styled.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: #ffffff14;
  }
`;
const InputStyled = styled.button`
  display: flex;
  align-items: center;
  width: 298px;
  background-color: transparent;
  border: none;
  padding-top: 5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
`;

const Input = styled.input`
  width: 90%;
  background-color: transparent;
  color: white;
  border: none;
  &::placeholder {
    color: #fff;
  }
`;

const ButtonUp = {
  position: "absolute",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100px",
  height: "50px",
  backgroundColor: "#51787D",
  border: "none",
  cursor: "pointer",
  top: "85%",
  right: "0",
};
const FooterWeb = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [privacyModalVisible, setPrivacyModalVisible] = useState(false);
  const [TermsAndConditionsModalVisible, setTermsAndConditionsModalVisible] = useState(false);
  const { selectedLanguage } = useLanguage();


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.length > 0) {
      NewsletterService.addNewsletter({ email: email })
        .then((response) => {
          console.log(response.data);
          setSubscribed(true);
          setTimeout(() => {
            setSubscribed(false);
            setEmail("");
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
          setEmail("");
        });
    }
  };
  return (
    <footer>
      <div style={FooterStyles}>
        <button style={ButtonUp} onClick={scrollToTop}>
          <svg
            width="35"
            height="49"
            viewBox="0 0 35 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="34"
              height="34"
              rx="17"
              stroke="white"
            />
            <path
              d="M22.8017 23.8012L18.0006 19L13.1992 23.8012H17.0555V49H18.9454V23.8012H22.8017Z"
              fill="white"
            />
          </svg>
        </button>
        <div style={FooterColumnStyles}>
          <div style={titleColumn1}>
            <b>{t("Contact BohoCasas")}</b>
            <br />
            <span>
              <b>{t("Phone")}</b>
            </span>
            <span>+351 265 104 072</span>
            <br />
            <span>
              <b>Email</b>
            </span>
            <span>contato@bohocasas.com</span>
            <br />
            <div style={getDirections}>
              <svg
                width="20"
                height="2"
                viewBox="0 0 20 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="0.5" width="20" height="1" fill="white" />
              </svg>
              <span>
                &nbsp;&nbsp;&nbsp;{" "}
                <Link
                  to="https://www.google.com/maps/dir//Boho+Casas,+Av.+Lu%C3%ADsa+Todi+406,+2900-455+Set%C3%BAbal/@38.5234376,-8.8999464,17z/data=!4m17!1m7!3m6!1s0xd194338b94a6c4d:0xcb2d56b8fae84d9f!2sBoho+Casas!8m2!3d38.5234376!4d-8.8973715!16s%2Fg%2F11v3gd20fp!4m8!1m0!1m5!1m1!1s0xd194338b94a6c4d:0xcb2d56b8fae84d9f!2m2!1d-8.8973715!2d38.5234376!3e3?entry=ttu"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  {t("GET DIRECTIONS")}
                </Link>
              </span>
            </div>
            {/* <span>
              <b>Premiação</b>
            </span> */}
            <img src="https://cursiversostorage.blob.core.windows.net/miosacademyimages/a1d39601-5e9d-40a8-bdae-e82fd3ef8604.png" width={100} height={100}/>
          </div>
        </div>
        <div style={FooterColumnStyles}>
          <span style={titleColumn2}>
            <b>{t("Useful Links")}</b>
            <br />
            <Link
              to="/services"
              onClick={handleClick}
              style={{
                textDecoration: "none",
                color: "white",
                paddingBottom: "10px",
              }}
            >
              {t("Our Services Useful Links")}
            </Link>
            <Link
              to="/services"
              onClick={handleClick}
              style={{
                textDecoration: "none",
                color: "white",
              }}
            >
              <CalculatorFooter type={"Footer"} />
            </Link>
            <a
              href="#AboutUs"
              onClick={scrollToAboutUs}
              style={{
                textDecoration: "none",
                color: "white",
                paddingBottom: "10px",
              }}
            >
              {t("About Boho Casas Useful Links")}
            </a>
            <Link
              to="https://livrodeelogios.com/"
              style={{
                textDecoration: "none",
                color: "white",
                paddingBottom: "10px",
              }}
            >
              {t("Book of compliments")}
            </Link>
            <Link
              to="https://www.livroreclamacoes.pt/Inicio"
              style={{
                textDecoration: "none",
                color: "white",
                paddingBottom: "10px",
              }}
            >
              {t("Complaint book")}
            </Link>
            <p onClick={() => { setPrivacyModalVisible(!privacyModalVisible) }} style={{
              paddingBottom: "10px",
              cursor: "pointer"
            }}>
              {selectedLanguage === "pt" ? "Política de Privacidade" : "Privacy Policy"}
              <PrivacyPolicyModal privacyModalVisible={privacyModalVisible} setPrivacyModalVisible={setPrivacyModalVisible} selectedLanguage={selectedLanguage} />
            </p>
            <p style={{
              cursor: "pointer",
              paddingBottom: "10px"
            }}
              onClick={() => { setTermsAndConditionsModalVisible(!TermsAndConditionsModalVisible) }}
            >
              {selectedLanguage === "pt" ? "Termos e Condições" : "Terms and Conditions"}
              <TermsAndConditionsModal TermsAndConditionsModalVisible={TermsAndConditionsModalVisible} setTermsAndConditionsModalVisible={setTermsAndConditionsModalVisible} selectedLanguage={selectedLanguage} />
            </p>
          </span>
        </div>

        <div style={FooterColumnStyles}>
          <div style={titleColumn4}>
            <b>{t("SIGN UP")}</b>
            <br />
            <span>{t("Call to action sign up")}</span>
            <br></br>
            <form onSubmit={handleSubmit} id="formNewsletter">
              <InputStyled>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder={t("Enter your email")}
                  value={email}
                  onChange={handleEmailChange}
                  onFocus={preventDefault}
                />
                <ButtonSubmit type="submit">
                  <svg
                    width="26"
                    height="24"
                    viewBox="0 0 26 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.9488 9.1698L8.5189 3.0698C5.56963 1.6198 2.36296 4.5498 3.85369 7.3298L5.59108 10.5698C6.07369 11.4698 6.07369 12.5298 5.59108 13.4298L3.85369 16.6698C2.36296 19.4498 5.56963 22.3698 8.5189 20.9298L20.9488 14.8298C23.394 13.6298 23.394 10.3698 20.9488 9.1698Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </ButtonSubmit>
              </InputStyled>
              {subscribed && <p>{t("Thank you for subscribing to us!")}</p>}
            </form>
            <br />
            <div
              style={{
                paddingTop: "40px",
                width: "230px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: '38px'
              }}
            >
              <Link to={'https://www.facebook.com/bohocasas'}>
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle opacity="0.16" cx="28" cy="28" r="28" fill="white" />
                  <path d="M32.209 28.5719H29.1959V37.5712H25.1783V28.5719H21.8839V24.8757H25.1783V22.0232C25.1783 18.8092 27.1067 17.0013 30.0395 17.0013C31.4457 17.0013 32.9322 17.2825 32.9322 17.2825V20.4564H31.285C29.678 20.4564 29.1959 21.4206 29.1959 22.4652V24.8757H32.7715L32.209 28.5719Z" fill="white" />
                </svg>
              </Link>
              <Link to={'https://www.instagram.com/bohocasas'}>
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle opacity="0.16" cx="28" cy="28" r="28" fill="white" />
                  <path d="M28.1413 22.666C30.6724 22.666 32.7615 24.7552 32.7615 27.2863C32.7615 29.8575 30.6724 31.9065 28.1413 31.9065C25.57 31.9065 23.5211 29.8575 23.5211 27.2863C23.5211 24.7552 25.57 22.666 28.1413 22.666ZM28.1413 30.2994C29.7885 30.2994 31.1143 28.9736 31.1143 27.2863C31.1143 25.639 29.7885 24.3132 28.1413 24.3132C26.4539 24.3132 25.1281 25.639 25.1281 27.2863C25.1281 28.9736 26.4941 30.2994 28.1413 30.2994ZM34.007 22.5053C34.007 23.108 33.5248 23.5901 32.9222 23.5901C32.3196 23.5901 31.8375 23.108 31.8375 22.5053C31.8375 21.9027 32.3196 21.4206 32.9222 21.4206C33.5248 21.4206 34.007 21.9027 34.007 22.5053ZM37.0603 23.5901C37.1407 25.0766 37.1407 29.5361 37.0603 31.0226C36.98 32.4689 36.6586 33.7144 35.614 34.7991C34.5694 35.8437 33.2838 36.1651 31.8375 36.2454C30.351 36.3258 25.8915 36.3258 24.4049 36.2454C22.9586 36.1651 21.7132 35.8437 20.6284 34.7991C19.5839 33.7144 19.2625 32.4689 19.1821 31.0226C19.1018 29.5361 19.1018 25.0766 19.1821 23.5901C19.2625 22.1438 19.5839 20.8581 20.6284 19.8136C21.7132 18.769 22.9586 18.4476 24.4049 18.3672C25.8915 18.2869 30.351 18.2869 31.8375 18.3672C33.2838 18.4476 34.5694 18.769 35.614 19.8136C36.6586 20.8581 36.98 22.1438 37.0603 23.5901ZM35.1319 32.5895C35.614 31.4244 35.4935 28.6121 35.4935 27.2863C35.4935 26.0006 35.614 23.1883 35.1319 21.9831C34.8105 21.2197 34.2078 20.5769 33.4445 20.2957C32.2392 19.8136 29.4269 19.9341 28.1413 19.9341C26.8155 19.9341 24.0032 19.8136 22.8381 20.2957C22.0346 20.6171 21.4319 21.2197 21.1105 21.9831C20.6284 23.1883 20.749 26.0006 20.749 27.2863C20.749 28.6121 20.6284 31.4244 21.1105 32.5895C21.4319 33.393 22.0346 33.9956 22.8381 34.317C24.0032 34.7991 26.8155 34.6786 28.1413 34.6786C29.4269 34.6786 32.2392 34.7991 33.4445 34.317C34.2078 33.9956 34.8506 33.393 35.1319 32.5895Z" fill="white" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          background: "#51787D",
          height: "80px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <svg
          width="1920"
          height="1"
          viewBox="0 0 1920 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect opacity="0.15" width="1920" height="1" fill="white" />
        </svg>
        <br />
        <span
          style={{
            color: "white",
            fontSize: "16px",
            textAlign: "center",
            fontWeight: "700",
            lineHeight: "22px",
          }}
        >
          <div style={{ marginBottom: "2rem" }}>
            <span>{t("Copyright")}</span>
            <br />
            <span>
              {selectedLanguage === "pt" ? (
                <div onClick={() => window.open("https://mios.pt")} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, cursor: "pointer" }}>
                  <a
                    style={{
                      textDecoration: "none",
                      color: "white",
                      textAlign: "center",
                      alignSelf: "center",
                      justifySelf: "center",
                      fontSize: 12,
                    }}
                  >
                    Desenvolvido por MIOS
                  </a>
                  {/* <img style={{ height: 9, marginTop: 5 }} src="https://static.wixstatic.com/media/3c7062_b3da73e1389847749b303a51fad60bdd~mv2.png/v1/fill/w_119,h_38,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Logo%20Mios%20(3)_edited.png" /> */}
                </div>
              ) : (
                <div onClick={() => window.open("https://mios.pt")} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, cursor: "pointer" }}>
                  <a
                    style={{
                      textDecoration: "none",
                      color: "white",
                      textAlign: "center",
                      alignSelf: "center",
                      justifySelf: "center",
                      fontSize: 12
                    }}
                  >
                    Desenvolvido por MIOS
                  </a>
                  {/* <img style={{ height: 9, marginTop: 5 }} src="https://static.wixstatic.com/media/3c7062_b3da73e1389847749b303a51fad60bdd~mv2.png/v1/fill/w_119,h_38,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Logo%20Mios%20(3)_edited.png" /> */}
                </div>
              )}
            </span>
          </div>
        </span>
        <br />
      </div>
    </footer>
  );
};

export default FooterWeb;
